import {INavigationState} from "@core/store/navigation/navigation.state";
import {createSelector} from "@ngrx/store";
import {IRootState} from "@core/store/root.state";

const _selectNavigation = (state: IRootState) => state.navigation;

export const selectIsSidebarExpanded = createSelector(_selectNavigation, (state: INavigationState) => state.isSidebarExpanded);
export const selectIsAdminMode = createSelector(_selectNavigation, (state: INavigationState) => state.isAdminMode);
